import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import Link from '@mui/material/Link';

import Label from 'ui/text/Label';

import { t } from 'i18n/index';

const AuthSwitchLink = ({ to }) => {
  const isSignup = to === '/signup';

  return (
    <Label secondary padded>
      {isSignup
        ? t('account:switchLink:noClubQuestion')
        : t('account:switchLink:hasAccountQuestion')}
      <Link component={RouterLink} to={to} underline="hover" color="inherit">
        {isSignup
          ? t('account:switchLink:signUpCall')
          : t('account:switchLink:signInCall')}
      </Link>
    </Label>
  );
};

AuthSwitchLink.propTypes = {
  to: PropTypes.oneOf(['/login', '/signup']).isRequired,
};

export default AuthSwitchLink;
